import { getAccessibleSites } from '@lms/api-client/backend';
import { SidebarProvider } from '@lms/ui/sidebar';
import type { ReactNode } from 'react';
import useSWR from 'swr';
import { AdminHeader } from '@/components/admin-header';
import { MobileHeader } from '@/components/mobile-header';
import { useCurrentUser, useSiteAccess } from '@/features/auth/use-auth';
import { useBrand } from '@/features/branding/brand-provider';

// The admin sidebar + main-content layout. Ports the JSX of
// app/[brand]/admin/layout.tsx; the auth gate lives in admin-app.tsx.
export function Shell({ children }: { children: ReactNode }) {
  const { brand: site, slug } = useBrand();
  const { access } = useSiteAccess(slug);
  const { user } = useCurrentUser();
  const { data: sites } = useSWR('admin/accessible-sites', () =>
    getAccessibleSites(),
  );

  return (
    <SidebarProvider className="bg-muted/40 h-dvh overflow-auto">
      <AdminHeader
        site={site}
        access={access}
        slugs={sites ?? []}
        activeUser={{ name: user?.name ?? '' }}
      />
      <div className="min-h-full w-full">
        <MobileHeader site={site} />
        <main className="mt-12 flex flex-1 flex-col gap-4 p-4 md:mt-0 md:gap-8 md:p-8">
          {children}
        </main>
      </div>
    </SidebarProvider>
  );
}
